import * as React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
// import qs from 'query-string';
import { CurrentUser } from '@graphql/types';
// import { ProtectedRoute } from './ProtectedRoute';
import { VendorOrEventHandler } from './VendorOrEventHandler';

import { MarketingPage } from '../routes/marketing';
// import { PlatformAdminRouter } from '../routes/pladmin/Router';
// import { ProfileRouter } from '../routes/profile/Router';
import { DesignDemo, DesignShowcase, CreateWeddingWrapper, CreateEventInviteLanding } from '@routes/event/create';
import { Login } from '../routes/login/Login';
// import { Messenger } from '../routes/messenger/Router';
// import { SurveyPage } from '../routes/survey';

import { isAndroidOrIOS } from 'utils/isAndroidOrIOS';
import { TyingTheKnot } from '../routes/event/create';
import { ErrorPage } from '@components/Error';
import { ApolloError } from 'apollo-client';
import { AuthCallback } from '@routes/authorization/AuthCallback';
interface Props {
  currentUserContext?: CurrentUser;
  refetch: () => void;
}

export class Router extends React.Component<Props> {
  private showPreview = !isAndroidOrIOS();
  private customDomain?: string;
  constructor(props: Props) {
    super(props);
    if (
      document.domain !== 'localhost' &&
      document.domain.split('.')[1] !== 'withjoy' &&
      document.domain.split('.')[0] !== 'withjoy'
    ) {
      this.customDomain = document.domain.split('.')[0];
    }
  }

  // private currentUser() {
  //   return !!(this.props.currentUserContext && this.props.currentUserContext.me);
  // }

  // private isAdmin() {
  //   return !!(
  //     this.props.currentUserContext &&
  //     this.props.currentUserContext.me &&
  //     this.props.currentUserContext.me.joyAdmin
  //   );
  // }

  // private isVendor() {
  //   return !!(
  //     this.props.currentUserContext &&
  //     this.props.currentUserContext.me &&
  //     this.props.currentUserContext.me.vendors.length > 0
  //   );
  // }

  render() {
    return (
      <Switch>
        <Route
          path={'/callback'}
          render={({ history }) => {
            return <AuthCallback history={history} refetch={this.props.refetch} />;
          }}
        />
        {/* <Route
          path={'/instagram_callback'}
          render={props => {
            console.log(props);
            console.log(qs.parse(props.location.search));
            return <div>{JSON.stringify(props)}</div>;
          }}
        /> */}
        <Route path={'/login'} render={() => <Login />} />
        {/* <ProtectedRoute authorized={this.currentUser()} path={'/me'} render={() => <ProfileRouter />} />
        <ProtectedRoute authorized={this.currentUser()} path={'/dashboard'} render={() => <div>Dashboard</div>} />
        <ProtectedRoute authorized={this.isAdmin()} path={'/platform-admin'} render={() => <PlatformAdminRouter />} /> */}
        <Route
          path={'/preview'}
          render={designDemoProps =>
            this.showPreview ? <DesignDemo history={designDemoProps.history} /> : <Redirect to="/designs" />
          }
        />
        <Route
          path={'/createwedding/tying-the-knot'}
          exact={true}
          render={() => {
            return <TyingTheKnot refetch={this.props.refetch} currentUser={this.props.currentUserContext} />;
          }}
        />
        <Route
          path={'/createwedding/invited/:guid'}
          exact={true}
          render={props => {
            return <CreateEventInviteLanding history={props.history} guid={props.match.params.guid} />;
          }}
        />
        <Route path={'/createwedding'} render={() => <CreateWeddingWrapper />} />
        <Route
          path={'/designs'}
          render={designShowcaseProps => <DesignShowcase history={designShowcaseProps.history} />}
        />
        {/* <Route
          path={'/rfp'}
          render={props => {
            const id = props.location.search || null;
            return <div>ID: {id}</div>;
          }}
        /> */}
        {/* <Route
          path={'/survey/:surveyId/:surveyResponseId'}
          render={({ match }) => (
            <SurveyPage surveyId={match.params.surveyId} surveyResponseId={match.params.surveyResponseId} />
          )}
        />
        <Route
          path={'/messages/:conversationId'}
          render={({ match }) => <Messenger conversationId={match.params.conversationId} />}
        /> */}
        {!this.customDomain ? (
          <Route
            // authorized={this.isVendor()}
            path={'/:handle'}
            render={({ match }) => (
              <VendorOrEventHandler handle={match.params.handle} currentUser={this.props.currentUserContext} />
            )}
          />
        ) : (
          undefined
        )}
        <Route
          exact={true}
          path={this.customDomain ? '*' : '/'}
          render={() => {
            if (this.customDomain) {
              const eventName = document.domain.split('.')[0];
              return <VendorOrEventHandler handle={eventName} customDomain={true} />;
            } else {
              return <MarketingPage />;
            }
          }}
        />
        <Route
          render={() => (
            <ErrorPage
              page="404"
              pagePrefix="marketing"
              category="Bliss"
              attemptedAction="Current User Query"
              error={
                new ApolloError({
                  networkError: new Error('Error 404: Page not found'),
                  errorMessage: 'Error 404: Page not found'
                })
              }
            />
          )}
        />
      </Switch>
    );
  }
}
